import { useContext } from 'react';
import userContext from 'context/user-context';

const useUser = () => {
  return useContext(userContext);
};

export default useUser;
